import { useContext } from 'react';
import { Context } from '../components/Globals/Globals.js';

function useGlobals() {
  return useContext(Context);
}

export { useGlobals as default };
//# sourceMappingURL=useGlobals.js.map
